import defNumberFormat from '../../../modules/functions/numberFormat';

export const numberFormat = (value: number): string => defNumberFormat(value);

export const padWithLeadingZeros = (number: number|string, totalLength: number = 2): string => {
    return String(number).padStart(totalLength, '0');
}
